import { render, staticRenderFns } from "./Penolakan.vue?vue&type=template&id=21b181ba&"
import script from "./Penolakan.vue?vue&type=script&lang=js&"
export * from "./Penolakan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports